/**
 * @file titles.ts
 * @brief Courtesy titles for user profiles (mirrors mobile `TITLES`).
 *
 * @author DES
 * @date 19-06-2026
 */

export type TitleOption = { code: string; label: string };

export const TITLES: TitleOption[] = [
  { code: "mr", label: "Mr." },
  { code: "mrs", label: "Mrs." },
  { code: "ms", label: "Ms." },
  { code: "miss", label: "Miss" },
  { code: "dr", label: "Dr." },
  { code: "prof", label: "Prof." },
  { code: "rev", label: "Rev." },
  { code: "hon", label: "Hon." },
  { code: "sir", label: "Sir" },
  { code: "dame", label: "Dame" },
  { code: "lord", label: "Lord" },
  { code: "lady", label: "Lady" },
  { code: "capt", label: "Capt." },
  { code: "col", label: "Col." },
  { code: "maj", label: "Maj." },
  { code: "lt", label: "Lt." },
  { code: "sgt", label: "Sgt." },
];

export function findTitle(value?: string | null): TitleOption | undefined {
  if (!value?.trim()) return undefined;
  const needle = value.trim().toLowerCase();
  return TITLES.find(
    (t) =>
      t.code === needle ||
      t.label.toLowerCase() === needle ||
      t.label.replace(/\.$/, "").toLowerCase() === needle,
  );
}

export function titleDisplayAbbrev(title: TitleOption, maxLen = 3): string {
  return title.label.replace(/\.$/, "").slice(0, maxLen);
}
